module.exports = __webpack_public_path__ + "img/marxism-overview.54fb9a38.jpg";